<template>
  <div>
    <el-form :model="formObject" :rules="rules" ref="adActiveForm" label-width="80px" size="mini">

      <el-form-item label="更多地址" prop="moreUrl" required>
        <el-input v-model="formObject.moreUrl" :disabled="type == 2"></el-input>
      </el-form-item>

      <el-form-item label="展示地址" prop="url" required>
        <el-input v-model="formObject.url" :disabled="type == 2"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="jumpUrl" required>
        <el-input v-model="formObject.jumpUrl" :disabled="type == 2"></el-input>
      </el-form-item>

      <el-form-item label="预售时间" required>
        <el-col :span="11">
          <el-form-item prop="beginDate">
            <el-date-picker
              :disabled="type == 2"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formObject.beginDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line txt-center" :span="2">-</el-col>
        <el-col :span="11">
          <el-form-item prop="finishDate">
            <el-date-picker
              :disabled="type == 2"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束时间"
              v-model="formObject.finishDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="状态" prop="status" required>
        <el-radio-group v-model="formObject.status" :disabled="type == 2 || statusDisable">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div class="dialog-footer mgt-10 txt-right">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" v-if="type != 2" type="primary" @click="finishDialog">保 存</el-button>
    </div>
  </div>
</template>

<script>
  import {Message} from '@/components'
  import { mapState } from 'vuex'
  export default {
    name: 'ActiveAdminBooking',
    props: {
      formObject: {
        type: Object,
        required: true
      },
      // 0: 新增,1: 修改,2:查看
      type: {
        type: Number,
        default: 0
      }
    },
    watch: {
      type: function () {
        switch (this.type) {
          case 0:
            this.$refs['adActiveForm'].resetFields()
            break;
          default:
            break;
        }
      }
    },
    data() {
      return {
        dialogVisible: false,
        popShow: false,
        proLoading: false,
        projects: [],
        selectProjects: [],
        queryProject(query, item) {
          return item.name.indexOf(query) > -1;
        },
        rules: {
          type: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          mainTitle: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          subTitle: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          flag: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          urlType: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          beginDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          finishDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          dateState: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          imgUrl: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
        }
      }
    },
    created() {
      this.proLoading = true
      this.$store.dispatch('adAdmin/getProjectsByUser').then(result => {
        this.projects = result
      }).finally(() => this.proLoading = false)
    },
    computed: {
      ...mapState("adAdmin", ['statusDisable']),
      fileList() {
        if (!this.formObject.imgUrl) return []
        return [{id: 0, url: this.formObject.imgUrl}]
      }
    },
    methods: {
      handleRemove() {
        this.formObject.imgUrl = ''
      },
      handleSuccess(res) {
        this.formObject.imgUrl = res.url
      },
      cancel() {
        this.popShow = false
      },
      select() {
        this.formObject.projects = []
        this.popShow = false
        this.projects.forEach(project => {
          if (this.selectProjects.indexOf(project.projectID) > -1) {
            this.formObject.projects.push({projectName: project.name, projectId: project.projectID, linkAdd: ''})
          }
        })
      },
      handleClose() {
        this.$emit('close')
      },
      finishDialog() {
        this.$refs['adActiveForm'].validate((valid) => {
          if (valid) {
            this.$emit('finish')
            return true
          } else {
            Message.warning({message: '请正确填写表单项'})
            return false
          }
        })
      },
    }
  };
</script>

<style scoped>
</style>
